/*  ========================================================================
    # Component - Application Form - Recommendation Input
    ========================================================================  */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useTranslation from '../../hooks/useTranslation';

const RecommendationInput = ({ options }) => {
  const __ = useTranslation();
  const [recommendation, setRecommendation] = useState('');

  const selectedOption = options.find(option => String(option.value) === recommendation);
  const showDetailInput = Boolean(selectedOption?.needsDetail);

  return (
    <>
      <fieldset className="c-form__item c-form__item--full">
        <label htmlFor="recommendation">{__('form-label-recommendation')}</label>
        <select
          name="recommendation"
          id="recommendation"
          value={recommendation}
          onChange={e => setRecommendation(e.target.value)}
        >
          <option value="" disabled>
            {__('form-option-recommendation-placeholder')}
          </option>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </fieldset>
      {showDetailInput && (
        <fieldset className="c-form__item c-form__item--full">
          <label htmlFor="recommendationDetail">{__('form-label-recommendation-detail')}</label>
          <input type="text" id="recommendationDetail" name="recommendationDetail" />
        </fieldset>
      )}
    </>
  );
};

RecommendationInput.propTypes = {
  options: PropTypes.array
};

RecommendationInput.defaultProps = {
  options: []
};

export default RecommendationInput;
